import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = '/api/h5'
// 请求拦截器
axios.interceptors.request.use(config => {
  return config
}, function (error) {
  return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use(config => {
  return config
}, function (error) {
  if (error.response) {
    if (error.response.status === 401) {
      return 401
    }
  }
  return Promise.reject(error)
})
// axios.interceptors.response.use
Vue.config.productionTip = false
Vue.prototype.$http = axios